<template>
  <el-dialog :visible.sync="localVisible" center @close="handleClose" width="700px">
    <div v-if="showTable">
      <div class="noteTitle">线下培训班通知</div>
      <el-table :data="gridData"  style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="noticeTitle" label="通知标题" align="center"></el-table-column>
        <el-table-column prop="createTime" label="通知时间" align="center" width="160"></el-table-column>
        <el-table-column label="阅读状态" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.readStatus === '01'" class="read"><span class="cicle"></span> 已读</div>
            <div v-if="scope.row.readStatus === '02'" class="noread"><span class="cicle"></span>未读</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <div
              :style="{ color: scope.row.readStatus === '01' ? '#999' : '#3172f6' }"
              @click="handleDetail(scope.row)"
            >
              查看详情
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div v-else style="text-align: center; padding: 20px;">暂无通知</div> -->

      <el-pagination
        v-show="total > 0"
        style="margin-top: 20px; text-align: right"
        :total="total"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      />
    </div>

    <div v-else>
      <div style="display: flex; position: relative">
        <div class="back" @click="handleBack">
          <img src="@/assets/images/left.png" alt="" /> <span>返回列表</span>
        </div>
        <div class="noteTitle">{{ infoDetail.noticeTitle == null ? '通知详情' : infoDetail.noticeTitle}}</div>
      </div>
      <div class="time">{{ infoDetail.createTime }}</div>
      <div class="content">{{ infoDetail.noticeContent }}</div>
      <div class="btn_know">
        <el-button type="primary" @click="getOk">我知道了</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getUserNotice } from '@/api/index.js';
import { getNoticeDetail } from '@/api/tzgg.js';
import { mapMutations } from 'vuex';
export default {
  name: 'NoticeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localVisible: this.visible,
      showTable: true,
      gridData: [],
      // unReadCount: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      infoDetail: {}
    };
  },
  watch: {
    visible(val) {
      console.log(val,'55');
      
      this.localVisible = val;
      if (val) {
        this.pageNum = 1;
        this.getNote();
      }
    },
    localVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    ...mapMutations('m_user', ['SET_UNREAD_COUNT']),
    async getNote() {
      const res = await getUserNotice({ pageNum: this.pageNum, pageSize: this.pageSize });
      this.total = res.data.total;
      this.gridData = res.data.rows;
      if (res.data.rows[0]) {
        this.unReadCount = res.data.rows[0].unReadCount;
      }
       const count = res.data.rows && res.data.rows[0] ? res.data.rows[0].unReadCount : 0;
  this.SET_UNREAD_COUNT(count);
    },
    handleDetail(row) {
      this.showTable = false;
      getNoticeDetail({ noticeId: row.noticeId }).then(res => {
        this.infoDetail = res.data.data;
      });
    },
    handleClose() {
      this.showTable = true;
      this.pageNum = 1;
      this.$emit('update:visible', false);
    },
    handleBack() {
      this.showTable = true;
      this.pageNum = 1;
      this.getNote();
    },
    getOk() {
      this.localVisible = false;
      this.pageNum = 1;
      this.getNote();
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.getNote();
    }
  }
};
</script>

<style scoped lang="less" >
/deep/.el-table__header,
.el-table__header-wrapper {
  background-color: #ebf3ff !important;
}
.read {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  .cicle {
    width: 8px;
    height: 8px;
    background: #999999;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
  }
}
.noread {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .cicle {
    width: 8px;
    height: 8px;
    margin-right: 6px;
    display: inline-block;
    background: #ff0000;
    border-radius: 50%;
  }
}
.back {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  img {
    width: 16px;
    height: 16px;
  }
}
.noteTitle {
  width: 100%;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-bottom: 24px;
}
.time {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-align: center;
}
.content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
.btn_know {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}
::v-deep .el-dialog__body {
  padding-top: 0 !important;
}
</style>